import { EventRow } from './logger.event-row';
import { loggerConstants } from 'app/logger/logger.constants';

export const inlinePackageEventType = {
    ReadPackageFailed: 'ReadPackageFailed',
    Parameterize: 'Parameterize',
    Download: 'Download',
    UnSupportedProtectionLevel: 'UnsupportedProtectionLevel',
    UnSupportChildPackage: 'UnSupportChildPackage',
    CompressPackage: 'CompressPackage',
    ActivityInlinePackageUsage: 'ActivityInlinePackageUsage',
    PipelineOverSize: 'PipelineOverSize',
    ToPayload: 'ToPayload'
};

export class SsisInlinePackageEvent extends EventRow {

    public constructor(componentName: string, eventType: string, message?: string) {
        super(loggerConstants.Event_SSISInlinePackage, { componentName });
        this.addToProperties('inlinePackageEventType', eventType);
        if (message) {
            this.addToProperties('message', message);
        }
    }
}
